/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const PrivacyScreen =
  Platform.OS === 'web' ? require('./privacy.web').default : require('./privacy.native').default;

export default PrivacyScreen;
